<div class="text-center loader">
	<i class="icon-gear icon-spin icon-3x"></i>
	<div *ngIf="message">{{message}}</div>
</div>